import { cloneDeep, isEqual } from 'lodash-es';
import { SelectBy } from '../interfaces/sort-by.interface';
import { HttpParams } from '@angular/common/http';
import { ConfigService } from '../../app/services/config/config.service';

export class BaseService {
    cloneAndRemoveNulls(obj: any): any {
        return this.trimAllProperties(this.removeNulls(cloneDeep(obj)));
    }

    isDeepEqual(obj1: any, obj2: any): boolean {
        const newObject1 = this.cloneAndRemoveNulls(obj1);
        const newObject2 = this.cloneAndRemoveNulls(obj2);
        return isEqual(newObject1, newObject2);
    }

    getSortHeaders(sortBy: SelectBy): HttpParams {
        let params = new HttpParams();
        if (sortBy) {
            params = params.append('sortDirection', sortBy.order);
            params = params.append('sortColumn', sortBy.type);
        }

        return params;
    }

    getApiUrl(ms = '', version = 'v1') {
        if (ms === 'branchOffices') {
            return ConfigService.get('apiUrlBranchOffices') + '/' + version;
        } else {
            return ConfigService.get('apiUrl') + '/' + version;
        }
    }

    private removeNulls(object: any) {
        this.removeNullsRecursively(object);
        return object;
    }

    private removeNullsRecursively(object: any) {
        for (const prop of Object.keys(object)) {
            if (prop === 'phoneNumber' || prop === 'phone') {
                if (!object[prop] || (typeof object[prop] !== 'string' && !object[prop].nationalNumber)) {
                    delete object[prop];
                }
            } else if (object[prop] == null || object[prop] === ''
                || typeof object[prop] === 'object' && this.removeNullsRecursively(object[prop])) {
                delete object[prop];
            }
        }
        return Object.keys(object).length === 0;
    }

    private trimAllProperties(object: any): any {
        for (const prop of Object.keys(object)) {
            if (object[prop]) {
                if (typeof object[prop] === 'string') {
                    object[prop] = object[prop].trim();
                } else if (typeof object[prop] === 'object') {
                    this.trimAllProperties(object[prop]);
                }
            }
        }

        return object;
    }
}
